var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTeamTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 172,
    viewBox: "0 0 278 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2293_13555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 42,
    width: 178,
    height: 72,
    rx: 18,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 64,
    width: 99,
    height: 12,
    rx: 6,
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 86,
    width: 88,
    height: 8,
    rx: 4,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 77H90C90.5523 77 91 76.5523 91 76C91 75.4477 90.5523 75 90 75H85C84.4477 75 84 75.4477 84 76C84 76.5523 84.4477 77 85 77Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 81H90C90.5523 81 91 80.5523 91 80C91 79.4477 90.5523 79 90 79H85C84.4477 79 84 79.4477 84 80C84 80.5523 84.4477 81 85 81Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5125 73C77.5125 73 79.1694 73 80.3409 74.1716C80.3409 74.1716 81.5125 75.3431 81.5125 77C81.5125 77 81.5125 78.6569 80.3409 79.8284C80.3409 79.8284 79.1694 81 77.5125 81C77.5125 81 75.8557 81 74.6841 79.8284C74.6841 79.8284 73.5125 78.6569 73.5125 77C73.5125 77 73.5125 75.3431 74.6841 74.1716C74.6841 74.1716 75.8557 73 77.5125 73ZM77.5125 75C77.5125 75 76.6841 75 76.0983 75.5858C76.0983 75.5858 75.5125 76.1716 75.5125 77C75.5125 77 75.5125 77.8284 76.0983 78.4142C76.0983 78.4142 76.6841 79 77.5125 79C77.5125 79 78.3409 79 78.9267 78.4142C78.9267 78.4142 79.5125 77.8284 79.5125 77C79.5125 77 79.5125 76.1716 78.9267 75.5858C78.9267 75.5858 78.3409 75 77.5125 75Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.352 81.6223C80.1631 82.2519 80.4183 83.2461 80.4183 83.2461L80.4185 83.2471C80.5318 83.6896 80.9308 84 81.3875 84L81.4076 83.9998C81.4845 83.9983 81.561 83.9879 81.6356 83.9688C82.078 83.8555 82.3875 83.4568 82.3875 83L82.3873 82.9799C82.3858 82.903 82.3753 82.8265 82.3563 82.752C81.9314 81.0927 80.5784 80.0424 80.5784 80.0424C79.2253 78.9922 77.5125 78.9922 77.5125 78.9922C75.7997 78.9922 74.4467 80.0424 74.4467 80.0424C73.0936 81.0927 72.6688 82.752 72.6688 82.752C72.648 82.833 72.6375 82.9164 72.6375 83C72.6375 83.0143 72.6378 83.0285 72.6384 83.0427C72.6455 83.2074 72.6931 83.3678 72.7771 83.5096C72.9123 83.7378 73.1325 83.903 73.3895 83.9688C73.4705 83.9895 73.5539 84 73.6375 84C73.6517 84 73.666 83.9997 73.6802 83.9991C73.8449 83.9921 74.0053 83.9444 74.1471 83.8604C74.3753 83.7253 74.5405 83.505 74.6063 83.2481C74.8612 82.2525 75.673 81.6223 75.673 81.6223C76.4848 80.9922 77.5125 80.9922 77.5125 80.9922C78.5402 80.9922 79.352 81.6223 79.352 81.6223Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 69C69 69 69 68.1716 69.5858 67.5858C69.5858 67.5858 70.1716 67 71 67H93C93 67 93.8284 67 94.4142 67.5858C94.4142 67.5858 95 68.1716 95 69V87C95 87 95 87.8284 94.4142 88.4142C94.4142 88.4142 93.8284 89 93 89H71C71 89 70.1716 89 69.5858 88.4142C69.5858 88.4142 69 87.8284 69 87V69ZM71 69V87H93V69H71Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2293_13555",
    x: 0,
    y: 0,
    width: 278,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2293_13555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2293_13555",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeamTemplate);
export default __webpack_public_path__ + "static/media/noTeamTemplate.198f56464099200401559efe14bfa627.svg";
export { ForwardRef as ReactComponent };